import React, {useEffect} from "react";
import {BasicProps} from "../Main";
import {useNavigate, useSearchParams} from "react-router-dom";

export const Callback: React.FC<BasicProps> = (props) => {
    const [params, ] = useSearchParams();
    const navigate = useNavigate();

    useEffect(() => {
        if (!params.has("token")) {
            alert("Sign in was not successful.")
        } else {
            localStorage.setItem("token", params.get("token") as string)

            if (params.has("nav")) {
                localStorage.setItem("sso-navigation", params.get('nav') as string)
            }

            window.dispatchEvent(new Event("sso-state"));

            window.close()

            props.setShowCover(true);

            setTimeout(() => {
                navigate("/");
            }, 3000)
        } // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return (
        <></>
    )
}